module.exports = __webpack_public_path__ + "img/logo1.fe7e2204.png";